import React, { Component } from 'react';
import { getSelectedBranchId } from '../utils/branch';
import PaginationComponent from '../components/PaginationComponent';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';

var config = process.env;

const STATUS = {
    0: 'Pendiente',
    1: 'En tránsito',
    2: 'Recibida',
    3: 'Cancelada',
};

class StockTransferComponent extends Component {

    getEmptyItem = () => ({ productCode: '', quantity: 1 });

    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            products: [],
            data: [],
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'id',
            sortDir: 'desc',
            loaded: false,
            fromBranchId: '',
            toBranchId: '',
            notes: '',
            items: [this.getEmptyItem()],
            showTransferModal: false,
            selectedTransfer: null,
            isSubmitting: false,
        };
    }

    componentDidMount() {
        this.loadBranches();
        this.fetchData();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    getSelectedBranchId = () => getSelectedBranchId();

    getSelectedBranchIdOrNull = () => {
        const selectedBranchId = this.getSelectedBranchId();
        if (!selectedBranchId || selectedBranchId === 'all') {
            return null;
        }

        return Number(selectedBranchId);
    }

    loadBranches = () => {
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch`, {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            const branches = data.data || [];
            const fromBranchId = this.state.fromBranchId || (branches[0] ? String(branches[0].id) : '');
            const toBranchId = this.state.toBranchId || (branches[1] ? String(branches[1].id) : '');

            this.setState({
                branches,
                fromBranchId,
                toBranchId,
            }, () => {
                if (fromBranchId) {
                    this.loadProducts(fromBranchId);
                }
            });
        });
    }

    loadProducts = (branchId) => {
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/${branchId}/product`, {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.setState({ products: data.data || [] });
        });
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        const selectedBranchId = this.getSelectedBranchId();
        const query = buildPaginationQuery({
            page,
            limit,
            search,
            sortBy,
            sortDir,
            extraParams: {
                branchId: selectedBranchId || undefined,
            },
        });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}stock-transfer?${query}`, {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                return;
            }
            const paginatedData = getPaginatedData(data);
            this.setState({
                data: paginatedData.items || [],
                quantityShowRows: paginatedData.limit || Number(limit),
                currentPage: paginatedData.page || Number(page),
                totalItems: paginatedData.total || 0,
                search,
                sortBy,
                sortDir,
                loaded: true,
            });
        })
        .catch(() => {
            this.setState({ loaded: true });
        });
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    onChangeBranch = (field, value) => {
        this.setState({ [field]: value }, () => {
            if (field === 'fromBranchId') {
                this.loadProducts(value);
            }
        });
    }

    updateItem = (index, field, value) => {
        this.setState((prevState) => ({
            items: prevState.items.map((item, currentIndex) => (
                currentIndex === index
                    ? { ...item, [field]: value }
                    : item
            )),
        }));
    }

    addItem = () => {
        this.setState((prevState) => ({
            items: [...prevState.items, this.getEmptyItem()],
        }));
    }

    removeItem = (index) => {
        this.setState((prevState) => ({
            items: prevState.items.filter((_, currentIndex) => currentIndex !== index),
        }));
    }

    resetTransferForm = () => {
        this.setState((prevState) => ({
            notes: '',
            items: [this.getEmptyItem()],
            showTransferModal: false,
            toBranchId: prevState.toBranchId || (prevState.branches[1] ? String(prevState.branches[1].id) : ''),
        }));
    }

    openTransferModal = () => {
        this.setState((prevState) => ({
            showTransferModal: true,
            items: prevState.items.length > 0 ? prevState.items : [this.getEmptyItem()],
        }));
    }

    closeTransferModal = () => {
        if (this.state.isSubmitting) {
            return;
        }

        this.resetTransferForm();
    }

    openTransferDetailModal = (transfer) => {
        this.setState({ selectedTransfer: transfer });
    }

    closeTransferDetailModal = () => {
        this.setState({ selectedTransfer: null });
    }

    createTransfer = () => {
        const items = this.state.items
            .filter((item) => item.productCode && Number(item.quantity) > 0)
            .map((item) => ({
                productCode: Number(item.productCode),
                quantity: Number(item.quantity),
            }));

        if (!this.state.fromBranchId || !this.state.toBranchId || items.length === 0) {
            alert('Completa origen, destino y al menos un producto.');
            return;
        }

        this.setState({ isSubmitting: true });

        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}stock-transfer`, {
            method: 'POST',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                fromBranchId: Number(this.state.fromBranchId),
                toBranchId: Number(this.state.toBranchId),
                notes: this.state.notes,
                items,
            }),
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.resetTransferForm();
            this.fetchData();
            this.loadProducts(this.state.fromBranchId);
        })
        .finally(() => {
            this.setState({ isSubmitting: false });
        });
    }

    updateTransferStatus = (id, action) => {
        const selectedBranchId = this.getSelectedBranchId();
        const branchQuery = selectedBranchId ? `?branchId=${selectedBranchId}` : '';
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}stock-transfer/${id}/${action}${branchQuery}`, {
            method: 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.fetchData();
            if (this.state.fromBranchId) {
                this.loadProducts(this.state.fromBranchId);
            }
        });
    }

    renderItemsForm = () => {
        return (
            <div
                style={{
                    border: '1px solid #e1e5eb',
                    borderRadius: '0.9rem',
                    background: '#f8fafc',
                    overflow: 'hidden',
                }}
            >
                <div className="table-responsive">
                    <table className="table mb-0" style={{ background: 'transparent' }}>
                        <thead>
                            <tr>
                                <th style={{ borderTop: 0, width: '65%', color: '#818ea3', fontWeight: 600 }}>Producto</th>
                                <th style={{ borderTop: 0, width: '20%', color: '#818ea3', fontWeight: 600 }}>Cantidad</th>
                                <th style={{ borderTop: 0, width: '15%' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.items.map((item, index) => (
                                <tr key={index}>
                                    <td className="align-middle">
                                        <select
                                            className="custom-select"
                                            value={item.productCode}
                                            onChange={(event) => this.updateItem(index, 'productCode', event.target.value)}
                                        >
                                            <option value="">Seleccionar producto</option>
                                            {this.state.products
                                                .filter((product) => Number(product.stock) > 0)
                                                .map((product) => (
                                                    <option key={product.code} value={product.code}>
                                                        {product.name} (stock: {product.stock})
                                                    </option>
                                                ))}
                                        </select>
                                    </td>
                                    <td className="align-middle">
                                        <input
                                            type="number"
                                            min="1"
                                            className="form-control"
                                            value={item.quantity}
                                            onChange={(event) => this.updateItem(index, 'quantity', event.target.value)}
                                        />
                                    </td>
                                    <td className="align-middle text-right">
                                        {this.state.items.length > 1 ? (
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger"
                                                style={{ minWidth: '96px', whiteSpace: 'nowrap' }}
                                                onClick={() => this.removeItem(index)}
                                            >
                                                Quitar
                                            </button>
                                        ) : (
                                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>-</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderTransferActions = (transfer) => {
        const selectedBranchId = this.getSelectedBranchIdOrNull();
        if (selectedBranchId == null) {
            return null;
        }

        const isOriginBranch = Number(transfer.fromBranchId) === selectedBranchId;
        const isDestinationBranch = Number(transfer.toBranchId) === selectedBranchId;

        if (Number(transfer.status) === 0) {
            if (!isOriginBranch) {
                return null;
            }
            return (
                <>
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => this.updateTransferStatus(transfer.id, 'send')}>
                        Enviar
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => this.updateTransferStatus(transfer.id, 'cancel')}>
                        Cancelar
                    </button>
                </>
            );
        }

        if (Number(transfer.status) === 1) {
            if (!isOriginBranch && !isDestinationBranch) {
                return null;
            }
            return (
                <>
                    {isDestinationBranch ? (
                        <button className="btn btn-sm btn-outline-success mr-2" onClick={() => this.updateTransferStatus(transfer.id, 'receive')}>
                            Recibir
                        </button>
                    ) : null}
                    {isOriginBranch ? (
                        <button className="btn btn-sm btn-outline-danger" onClick={() => this.updateTransferStatus(transfer.id, 'cancel')}>
                            Cancelar
                        </button>
                    ) : null}
                </>
            );
        }

        return null;
    }

    renderEmptyState = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div style={{ textAlign: 'center', maxWidth: '420px' }}>
                    <div
                        style={{
                            width: '72px',
                            height: '72px',
                            margin: '0 auto 1rem',
                            borderRadius: '50%',
                            background: '#f5f6f8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="material-icons" style={{ fontSize: '34px', color: '#818ea3' }}>swap_horiz</i>
                    </div>
                    <h4 style={{ marginBottom: '0.75rem', color: '#3d5170', fontWeight: 500 }}>
                        Todavía no hay transferencias para mostrar
                    </h4>
                    <p style={{ margin: 0, color: '#818ea3', lineHeight: 1.6 }}>
                        Cuando se generen movimientos de stock entre sucursales, acá vas a ver
                        el listado con su estado y los productos transferidos.
                    </p>
                </div>
            </div>
        );
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    drawRow = (transfer, index) => {
        const itemsCount = (transfer.items || []).length;
        return (
            <tr role="row" className="odd" key={transfer.id} style={{ background: index % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                <td tabIndex="0" className="sorting_1">{transfer.id}</td>
                <td>{transfer.fromBranchName}</td>
                <td>{transfer.toBranchName}</td>
                <td>{STATUS[transfer.status] || transfer.status}</td>
                <td>
                    <span className="badge badge-pill badge-light" style={{ fontSize: '0.8rem', padding: '0.45rem 0.7rem' }}>
                        {itemsCount} producto{itemsCount === 1 ? '' : 's'}
                    </span>
                </td>
                <td>
                    <div className="btn-group btn-group-sm" role="group" aria-label="Table row actions">
                        <button
                            type="button"
                            className="btn btn-white"
                            title="Ver detalle"
                            onClick={() => this.openTransferDetailModal(transfer)}
                        >
                            <i className="material-icons">visibility</i>
                        </button>
                        {this.renderTransferActions(transfer)}
                    </div>
                </td>
            </tr>
        );
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }
        const items = this.state.data.map((transfer, index) => this.drawRow(transfer, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty">
                    <td colSpan={6} style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                        {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                    </td>
                </tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    renderTransfers = () => {
        if (!this.state.loaded) {
            return this.renderLoader();
        }
        if (this.state.totalItems === 0 && !hasActiveSearch(this.state.searchInput, this.state.search)) {
            return this.renderEmptyState();
        }
        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer" style={{ padding: '0 1.5rem 1.5rem' }}>
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                    </label>
                </div>
                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.sortableHeader('id')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>ID</th>
                            <th {...this.sortableHeader('fromBranchName')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '20%' }}>Origen</th>
                            <th {...this.sortableHeader('toBranchName')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '20%' }}>Destino</th>
                            <th {...this.sortableHeader('status')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Estado</th>
                            <th rowSpan="1" colSpan="1" style={{ width: '10%' }}>Items</th>
                            <th rowSpan="1" colSpan="1" style={{ width: '25%' }}>Acciones</th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>
                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
            </div>
        );
    }

    renderTransferModal = () => {
        if (!this.state.showTransferModal) {
            return null;
        }

        return (
            <>
                <div className="modal fade show" style={{ display: 'block' }} role="dialog">
                    <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                        <div className="modal-content" style={{ borderRadius: '0.75rem' }}>
                            <div className="modal-header">
                                <div>
                                    <h4 className="modal-title mb-1">Nueva transferencia</h4>
                                    <small className="text-muted">
                                        Configurá origen, destino y los productos a mover entre sucursales.
                                    </small>
                                </div>
                                <button type="button" className="close" aria-label="Close" onClick={this.closeTransferModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div
                                className="modal-body"
                                style={{
                                    maxHeight: 'calc(100vh - 210px)',
                                    overflowY: 'auto',
                                }}
                            >
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label>Sucursal origen</label>
                                            <select
                                                className="custom-select"
                                                value={this.state.fromBranchId}
                                                onChange={(event) => this.onChangeBranch('fromBranchId', event.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                {this.state.branches.map((branch) => (
                                                    <option key={branch.id} value={branch.id}>{branch.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label>Sucursal destino</label>
                                            <select
                                                className="custom-select"
                                                value={this.state.toBranchId}
                                                onChange={(event) => this.onChangeBranch('toBranchId', event.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                {this.state.branches.map((branch) => (
                                                    <option key={branch.id} value={branch.id}>{branch.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label>Observaciones</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={this.state.notes}
                                                onChange={(event) => this.setState({ notes: event.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ marginTop: '1rem' }}>
                                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-3" style={{ gap: '0.5rem' }}>
                                        <label className="mb-0" style={{ fontWeight: 600 }}>Productos</label>
                                        <span className="text-muted" style={{ fontSize: '0.8rem' }}>
                                            Elegí los productos y cantidades a transferir
                                        </span>
                                    </div>
                                    {this.renderItemsForm()}
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-between flex-wrap" style={{ gap: '0.75rem' }}>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={this.addItem}
                                    disabled={this.state.isSubmitting}
                                >
                                    Agregar producto
                                </button>
                                <div className="d-flex align-items-center flex-wrap" style={{ gap: '0.75rem' }}>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={this.closeTransferModal}
                                        disabled={this.state.isSubmitting}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={this.createTransfer}
                                        disabled={this.state.isSubmitting}
                                    >
                                        Crear transferencia
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        );
    }

    renderTransferDetailModal = () => {
        const { selectedTransfer } = this.state;
        if (!selectedTransfer) {
            return null;
        }

        return (
            <>
                <div className="modal fade show" style={{ display: 'block' }} role="dialog">
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                        <div className="modal-content" style={{ borderRadius: '0.75rem' }}>
                            <div className="modal-header">
                                <div>
                                    <h4 className="modal-title mb-1">Detalle de transferencia #{selectedTransfer.id}</h4>
                                    <small className="text-muted">
                                        {selectedTransfer.fromBranchName} hacia {selectedTransfer.toBranchName}
                                    </small>
                                </div>
                                <button type="button" className="close" aria-label="Close" onClick={this.closeTransferDetailModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <div className="col-md-4 mb-3 mb-md-0">
                                        <div className="border rounded p-3 h-100">
                                            <small className="text-muted d-block mb-1">Origen</small>
                                            <strong>{selectedTransfer.fromBranchName}</strong>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3 mb-md-0">
                                        <div className="border rounded p-3 h-100">
                                            <small className="text-muted d-block mb-1">Destino</small>
                                            <strong>{selectedTransfer.toBranchName}</strong>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="border rounded p-3 h-100">
                                            <small className="text-muted d-block mb-1">Estado</small>
                                            <strong>{STATUS[selectedTransfer.status] || selectedTransfer.status}</strong>
                                        </div>
                                    </div>
                                </div>
                                {selectedTransfer.notes ? (
                                    <div className="mb-4">
                                        <small className="text-muted d-block mb-1">Observaciones</small>
                                        <div className="border rounded p-3" style={{ background: '#f8fafc' }}>
                                            {selectedTransfer.notes}
                                        </div>
                                    </div>
                                ) : null}
                                <div className="table-responsive">
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Producto</th>
                                                <th className="text-right">Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(selectedTransfer.items || []).map((item, index) => (
                                                <tr key={`${selectedTransfer.id}-${item.productCode}-${index}`}>
                                                    <td>{item.productName || item.productCode}</td>
                                                    <td className="text-right">{item.quantity}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={this.closeTransferDetailModal}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        );
    }

    render() {
        return (
            <>
                <div className="row">
                    <div className="col-lg-12 mb-4">
                        <div className="card">
                            <div className="d-flex justify-content-between align-items-center border-bottom" style={{ padding: '1rem 1.5rem' }}>
                                <span className="text-muted" style={{ fontSize: '0.95rem' }}>
                                    Visualizá el estado de cada movimiento entre sucursales.
                                </span>
                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.fetchData()}>
                                    Recargar
                                </button>
                            </div>
                            <div className="card-body p-0">
                                {this.renderTransfers()}
                            </div>
                        </div>
                    </div>
                </div>
                <div onClick={this.openTransferModal} className="color-switcher-toggle animated pulse infinite" style={{ right: '40px' }}>
                    <i className="material-icons">add</i>
                </div>
                {this.renderTransferModal()}
                {this.renderTransferDetailModal()}
            </>
        );
    }
}

export default StockTransferComponent;
